// truncate_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]
  static values = { limit: Number }

  connect() {
    // Set a default character limit if none is specified
    if (!this.hasLimitValue) {
      this.limitValue = 2047;
    }
  }

  truncate() {
    const maxLength = this.limitValue
    const text = this.textareaTarget.value

    if (text.length > maxLength) {
      // Truncate the text to the maximum length
      this.textareaTarget.value = text.slice(0, maxLength)
    }
  }
}
